export const businessPlanEditingArticle = {
  title: 'Business Plan Generator: Editing Sections',
  slug: 'business-plan-editing',
  content: `Business Plan Generator: Editing Sections

Edit sections after generation to keep the plan accurate and specific.

1) Open the plan document
- Select a plan from the saved plans list.
- Sections appear in the document view.

2) Edit sections
- Click the Edit button on any section.
- Use the editor tools for headings, bold, bullets, and lists.
- Save changes to update the plan.

3) Auto-save behavior
- The editor auto-saves changes after you stop typing.
- You can also click “Save Changes” to force a save.

4) Refresh when needed
- Use “Refresh” if the document feels out of date.
`,
};
